import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.028 13.183q.314.177.669.177h4.62q.342 0 .655-.178.313-.177.511-.49l2.332-4.024a1.29 1.29 0 0 0 0-1.336l-2.332-4.024a1.45 1.45 0 0 0-.511-.49 1.3 1.3 0 0 0-.654-.178H5.697q-.356 0-.669.178a1.34 1.34 0 0 0-.497.49L2.185 7.332a1.29 1.29 0 0 0 0 1.336l2.346 4.024q.185.313.497.49m.944-1.6a.9.9 0 0 0 .456.122h3.154a.9.9 0 0 0 .446-.123 1 1 0 0 0 .35-.339l1.59-2.781a.9.9 0 0 0 0-.924l-1.59-2.78a1 1 0 0 0-.35-.34.9.9 0 0 0-.446-.123H6.428a.917.917 0 0 0-.796.462l-1.6 2.781a.9.9 0 0 0 0 .924l1.6 2.781a.9.9 0 0 0 .34.34",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }